import { motion } from "framer-motion";
import { Eye, EyeOff } from "lucide-react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { formatIDR } from "../lib/api";
import { Button } from "./ui/button";

export default function BalanceCard({ user, loading }) {
    const [hidden, setHidden] = useState(false);
    const navigate = useNavigate();

    return (
        <motion.div
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-brand-deep via-brand-deep to-[#1E3A8A] dark:from-[#0a2540] dark:via-[#0a1a35] dark:to-[#063b2e] text-white p-5 shadow-xl shadow-brand-deep/20"
            data-testid="balance-card"
        >
            <div className="absolute -top-10 -right-10 h-40 w-40 rounded-full bg-brand-green/20 blur-3xl" />
            <div className="absolute -bottom-12 -left-8 h-32 w-32 rounded-full bg-blue-400/10 blur-3xl" />

            <div className="relative">
                <div className="flex items-center justify-between">
                    <div>
                        <div className="text-[11px] uppercase tracking-widest text-white/60 font-medium">Saldo Mitra</div>
                        <div className="text-xs text-white/70 mt-0.5">{user?.warung_name}</div>
                    </div>
                    <button
                        aria-label={hidden ? "Tampilkan saldo" : "Sembunyikan saldo"}
                        data-testid="toggle-balance-btn"
                        onClick={() => setHidden((v) => !v)}
                        className="p-2 rounded-full bg-white/10 hover:bg-white/20 transition"
                    >
                        {hidden ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
                    </button>
                </div>

                <div className="mt-4">
                    {loading ? (
                        <div className="h-9 w-44 bg-white/10 animate-pulse rounded-lg" />
                    ) : (
                        <div className="font-heading font-bold text-3xl tracking-tight" data-testid="balance-amount">
                            {hidden ? "Rp ••••••••" : formatIDR(user?.balance || 0)}
                        </div>
                    )}
                </div>

                                <div className="mt-5 flex flex-wrap gap-2">
                    <Button onClick={() => navigate("/deposit")} className="flex-1 bg-brand-green hover:bg-brand-greenDark text-white rounded-xl h-11">Top Up</Button>
                    <Button
                        data-testid="ledger-shortcut-btn"
                        onClick={() => navigate("/mutasi")}
                        variant="secondary"
                        className="flex-1 bg-white/10 hover:bg-white/20 text-white border-0 rounded-xl h-11 font-semibold backdrop-blur-sm"
                    >
                        Mutasi
                    </Button>
                    <Button
                        data-testid="history-shortcut-btn"
                        onClick={() => navigate("/riwayat")}
                        variant="secondary"
                        className="flex-1 bg-white/10 hover:bg-white/20 text-white border-0 rounded-xl h-11 font-semibold backdrop-blur-sm"
                    >
                        Riwayat
                    </Button>
                </div>
            </div>
        </motion.div>
    );
}
